module.exports = __webpack_public_path__ + "static/media/fanyuvo-event3.ec8cd707.jpg";